<style scoped>
</style>
<template>

    <Header id="layout-header">
        <div class="header-logo">
            <div class="header-logo-title">
                <h3 style="border:none">瀚土智能智能系统<span>v3.0</span></h3>
            </div>
        </div>
        <Row type="flex" justify="space-between">
            <Col>
                <!--顶部菜单-->
                <div class="header-menu">
                    <ul>
                        <li @click="setActiveIndex(1)" :class="[navActiveIndex == 1 ? 'active' : '']">
                            <a href="javascript:;">
                                <Icon class="category-icon" type="md-cube"></Icon>
                                <span>区域</span>
                            </a>
                        </li>
                        <li @click="setActiveIndex(2)" :class="[navActiveIndex == 2 ? 'active' : '']">
                            <a href="javascript:;">
                                <Icon class="category-icon" type="md-settings"></Icon>
                                <span>控制中心</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </Col>
            <Col >
                <!--右侧菜单-->
                <div class="header-right-menu">
                    <ul>
                        <!--<li><new-message></new-message></li>-->
                        <!--<li>-->
                            <!--<router-link to="/">-->
                              <!--<Icon class="category-item-icon" type="ios-construct"></Icon> <span>设备报修</span>-->
                            <!--</router-link>-->
                        <!--</li>-->
                        <li>
                            <router-link tag="a" target="_blank" :to="{name:'shuping',params:{catId:0}}">
                                <Icon class="category-item-icon" type="md-phone-portrait"></Icon> <span>生态屏</span>
                            </router-link>
                        </li>

                        <li>
                            <router-link tag="a" target="_blank" :to="{name:'daping',params:{catId:0}}">
                                <Icon class="category-item-icon" type="md-desktop"></Icon> <span>大屏模式</span>
                            </router-link>
                        </li>
                        <li>
                            <!--<Dropdown transfer trigger="hover" @on-click="handleClickUserDropdown">-->
                                <a href="javascript:void(0)">
                                    <Avatar :src="userInfo.headImg == undefined || userInfo.headImg == '' ? defaultPic : imgSrc+userInfo.headImg" />
                                    {{userInfo.nickName}}
                                    <!--<Icon class="category-icon" type="ios-arrow-down"></Icon>-->
                                </a>
                                <!--<DropdownMenu slot="list">-->
                                    <!--<DropdownItem>-->
                                        <!--<span @click="$func.jumps('set')" style="color:#515a6e">个人资料</span>-->
                                    <!--</DropdownItem>-->
                                    <!--<DropdownItem>-->
                                        <!--<span @click="$func.jumps('set')" style="color:#515a6e">设置</span>-->
                                    <!--</DropdownItem>-->
                                    <!--<DropdownItem name="loginOut" divided>退出登录</DropdownItem>-->
                                <!--</DropdownMenu>-->
                            <!--</Dropdown>-->
                        </li>
                        <li>
                          <full-screen v-model="isFullScreen" @on-change="fullScreenChange"></full-screen>
                        </li>
                        <li>
                            <Icon @click="loginOut" class="category-item-icon" type="md-power"></Icon>
                        </li>
                    </ul>
                </div>
            </Col>
        </Row>
    </Header>

</template>

<script>
import defaultPic from '@/assets/img/type2.png';
import { fullScreen, newMessage } from "./headerBar_components";
export default {
  components: {
    fullScreen,
    newMessage
  },
  data() {
    return {
        defaultPic:defaultPic,
        imgSrc:this.$func.imgSrc,
        isFullScreen: false //全屏关闭
    };
  },
  created() {

  },
  computed:{
    userInfo(){
      return this.$store.state.user.userInfo
    },
    navActiveIndex(){
        return this.$store.state.app.navActiveIndex
    }
  },
  methods: {
    fullScreenChange(isFullScreen) {
      // console.log(isFullScreen);
    },
    // handleClickUserDropdown(name) {
    //   const that = this;
    //   if (name === "loginOut") {
    //     // 退出登录
    //     that.$store.commit("loginOut");
    //   }
    // },
    loginOut(){
        const that = this;
        that.$Modal.confirm({
            title: '系统提示',
            content: '确定退出系统吗？',
            onOk: () => {
                // 退出登录
                that.$store.commit("loginOut");
            }
        })
    },
    setActiveIndex(index){
        this.activeIndex = index;
        this.$store.commit("setNavActiveIndex",index);
        if(index == 1){
            this.$router.replace({name:'znsb'})
        }else if(index == 2){
            this.$router.replace({name:'message'})
        }
    }
  }
};
</script>
